export default __webpack_public_path__ + "static/media/carousel-img2.44b1cfc8.jpg";